export default __webpack_public_path__ + "static/media/TerraCharge_splash01.bdfd7e51.png";